export default __webpack_public_path__ + "static/media/logo_n.d6e23571.svg";